interface DashboardCardContentValueChangeProps {
  value?: string;
}

export function DashboardCardContentValueChange({ value }: DashboardCardContentValueChangeProps) {
  return (
    <span className={`flex items-end text-[0.86625rem] ${value?.startsWith('-') ? 'text-positive' : 'text-negative'}`}>
      {value} <i className="ai ml-1 ai-statistic-up" />
    </span>
  );
}
